export enum ProjectRequirementStatus {
    Success = 'success',
    Failure = 'failure',
    InProgress = 'in-progress'
}
